module.exports = __webpack_public_path__ + "img/coinbankB14.7daa262b.jpg";